// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"2fd2e30b","213":"9d8b865d","239":"3c3f1aac","667":"a6d58ca2","777":"1924f9cf"}[chunkId] + ".chunk.js";
};